/* House of Dynast V7 on Horizon: card colour thumbnails, sticky header offset. */
(() => {
  'use strict';
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-hod-dot]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    const root = b.closest('.h7-cardw, product-card, .product-card');
    const img = root && root.querySelector('.h7-ph img, slideshow-slide img, .card-gallery img, img:not([data-hod-dot] img)');
    if (img) { img.removeAttribute('sizes'); img.srcset = b.dataset.srcset; img.src = b.dataset.src; img.sizes = '(min-width: 1060px) 22vw, 48vw'; }
    b.parentElement.querySelectorAll('[data-hod-dot]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
  }, true);
  const sec = document.querySelector('.hod7-header-section');
  const top = sec && sec.querySelector('.hod7-top');
  const set = () => { if (top) document.documentElement.style.setProperty('--hod7-top-h-neg', (-top.offsetHeight) + 'px'); };
  set();
  window.addEventListener('resize', set);
})();
/* Sticky bar mirrors the size guard on every product page (the Qingshan template has its own, richer version). */
(() => {
  if (document.querySelector('[data-hod-qs-buy]')) return;
  const bar = () => document.querySelector('sticky-add-to-cart');
  if (!bar()) return;
  const fs = (re) => Array.from(document.querySelectorAll('variant-picker fieldset')).find((f) => re.test((f.querySelector('legend') || {}).textContent || ''));
  const val = (f) => { const i = f && f.querySelector('input:checked'); return i ? i.value : ''; };
  let q = false;
  const sync = () => {
    q = false;
    const need = document.body.classList.contains('hod-needs-size');
    const sv = document.querySelector('.sticky-add-to-cart__variant');
    const sb = document.querySelector('.sticky-add-to-cart__button');
    if (!sb) return;
    let lab = sb.querySelector('.hod-qs-sticky-label');
    if (need) {
      const c = val(fs(/^\s*(colou?r|style)/i));
      const want = (c ? c + ' · ' : '') + 'choose a size';
      if (sv && sv.textContent.trim() !== want) sv.textContent = want;
      if (!lab) { lab = document.createElement('span'); lab.className = 'hod-qs-sticky-label'; lab.textContent = 'Choose size'; sb.appendChild(lab); }
      if (!sb.classList.contains('hod-qs-choose')) sb.classList.add('hod-qs-choose');
    } else {
      if (lab) lab.remove();
      if (sb.classList.contains('hod-qs-choose')) sb.classList.remove('hod-qs-choose');
    }
  };
  const later = () => { if (q) return; q = true; setTimeout(sync, 30); };
  new MutationObserver(later).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver((r) => { if (r.some((x) => !(x.target.closest && x.target.closest('.hod-qs-sticky-label')))) later(); }).observe(bar(), { childList: true, subtree: true, characterData: true });
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('.sticky-add-to-cart__button.hod-qs-choose');
    if (!b) return;
    const f = fs(/^\s*size/i);
    if (f) f.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
  later();
})();
/* Cart page: free-shipping progress inside the summary (the drawer is handled in hod-hz.js). */
(() => {
  const inner = () => document.querySelector('.cart-page .cart-summary__inner');
  if (!inner()) return;
  const FREE = (window.HOD && window.HOD.freeShip) || 10000;
  const rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  const fmt = (c) => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
  let busy = false, q = false;
  const run = async () => {
    q = false; const host = inner(); if (!host || busy) return; busy = true;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const goal = Math.round(FREE * rate), left = Math.max(0, goal - cart.total_price);
      const txt = left > 0 ? 'Add ' + fmt(left) + ' more for free shipping.' : 'Your order ships free.';
      let el = host.querySelector(':scope > .hod-ship');
      if (!el) { el = document.createElement('div'); el.className = 'hod-ship'; el.innerHTML = '<p></p><div class="hod-ship__bar" aria-hidden="true"><i></i></div>'; host.prepend(el); }
      const p = el.querySelector('p'); if (p.textContent !== txt) p.textContent = txt;
      const t = 'scaleX(' + Math.min(1, cart.total_price / goal).toFixed(3) + ')'; const i = el.querySelector('i'); if (i.style.transform !== t) i.style.transform = t;
    } catch (e) { /* optional */ }
    busy = false;
  };
  const later = () => { if (q) return; q = true; setTimeout(run, 250); };
  const root = document.querySelector('.cart-page');
  if (root) new MutationObserver((r) => { if (r.some((x) => !(x.target.closest && x.target.closest('.hod-ship')))) later(); }).observe(root, { childList: true, subtree: true });
  later();
})();
